import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUser, FaEnvelope } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const buttonRef = useRef(null);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        buttonRef.current &&
        !navRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };


    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };


    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const location = useLocation();

  return (
    <header>
      <div className="header-container">
        <Link to="/" className="logo-section">
          <img src="/images/logo.jpg" alt="Neralen Logo" className="logo-img" />
          <div className="logo-text">
            <h1>Neralen</h1>
            <p>Ζαχαροπλαστική Τέχνη</p>
          </div>
        </Link>
                <button 
          ref={buttonRef}
          className="hamburger-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

<nav ref={navRef} className={isMenuOpen ? 'active' : ''}>
          <ul>
            <li>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={closeMenu}>
                <FaHome /> Αρχική
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={closeMenu}>
                <FaUser /> Σχετικά
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={closeMenu}>
                <FaEnvelope /> Επικοινωνία
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;